import { render } from "./svgSert.vue?vue&type=template&id=4e125f6f&scoped=true&lang=true"
import script from "./svgSert.vue?vue&type=script&lang=js"
export * from "./svgSert.vue?vue&type=script&lang=js"

import "./svgSert.vue?vue&type=style&index=0&id=4e125f6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e125f6f"]])

export default __exports__